var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "none",
      transformOrigin: "50% 50%",
      cursor: "move"
    },
    width: 278,
    height: 422,
    viewBox: "0 0 2780 4220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l3nhDHLWswQLfMFetJBb68d",
    fill: "rgb(0,0,0)",
    style: {
      transform: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pFm0XBxR8",
    d: "M1341 4196 l-23 -24 25 -64 c34 -86 50 -169 50 -258 -1 -87 -16 -154 -78 -335 -24 -71 -51 -163 -60 -203 -31 -149 -13 -379 43 -542 l19 -55 -64 -2 c-46 -1 -71 -7 -92 -23 -35 -24 -41 -51 -24 -104 16 -46 84 -159 121 -199 16 -17 22 -31 16 -37 -5 -5 -49 -34 -97 -64 -253 -159 -586 -443 -782 -665 -276 -315 -395 -581 -395 -885 0 -169 37 -300 123 -431 84 -130 241 -240 400 -279 98 -25 259 -23 362 3 157 40 337 149 445 269 l52 57 81 -78 c133 -129 264 -206 422 -248 115 -30 283 -30 385 1 161 48 284 133 369 255 104 149 153 352 131 550 -41 387 -280 746 -770 1156 -119 100 -357 277 -446 332 l-50 31 59 93 c73 118 91 165 77 208 -14 41 -46 55 -140 62 -41 3 -78 11 -82 17 -9 12 -33 93 -54 176 -21 81 -29 283 -15 365 7 38 31 121 53 184 70 201 87 274 87 392 1 116 -20 221 -63 316 -28 60 -49 67 -85 29z m139 -1621 c0 -3 -19 -35 -43 -70 l-43 -65 -47 64 c-26 35 -47 67 -47 70 0 3 41 6 90 6 50 0 90 -2 90 -5z m37 -405 c431 -292 845 -703 987 -980 182 -354 163 -655 -55 -881 -75 -78 -167 -128 -285 -155 -91 -20 -175 -9 -303 39 -122 46 -215 112 -324 228 l-92 99 -61 0 -60 0 -60 -67 c-128 -146 -254 -231 -419 -283 -238 -74 -520 53 -634 285 -85 171 -91 324 -24 540 89 283 361 613 793 962 160 129 388 283 419 283 8 0 61 -32 118 -70z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "laU8GQyvqhqkDazkqE9JAm",
    fill: "rgb(222,75,107)",
    style: {
      transform: "none"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pvNZj0odw",
    d: "M1240 2596 c0 -15 136 -209 150 -214 14 -5 150 195 150 220 0 4 -67 8 -150 8 -121 0 -150 -3 -150 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pxSIcfAkT",
    d: "M350 705 c0 -31 3 -35 25 -35 14 0 25 -4 25 -10 0 -5 16 -10 35 -10 34 0 35 -2 35 -36 0 -27 5 -37 20 -41 11 -3 20 -14 20 -24 0 -11 7 -19 15 -19 8 0 15 -9 15 -20 0 -11 7 -20 15 -20 8 0 15 -9 15 -20 0 -11 5 -20 10 -20 6 0 10 -7 10 -15 0 -10 11 -15 35 -15 33 0 35 2 35 35 0 19 -4 35 -10 35 -5 0 -10 7 -10 15 0 8 -7 15 -15 15 -8 0 -15 9 -15 20 0 11 -7 20 -15 20 -8 0 -15 9 -15 20 0 11 -6 20 -14 20 -8 0 -16 10 -18 23 -2 18 -10 23 -40 25 -36 3 -38 5 -38 38 0 30 -3 34 -25 34 -14 0 -25 5 -25 10 0 6 -16 10 -35 10 -33 0 -35 -2 -35 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p16k5SitAa",
    d: "M260 575 l0 -75 35 0 35 0 0 75 0 75 -35 0 -35 0 0 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfypuZHqO",
    d: "M2480 485 c0 -33 2 -35 35 -35 33 0 35 2 35 35 0 33 -2 35 -35 35 -33 0 -35 -2 -35 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgKVm07hP",
    d: "M320 415 c0 -33 2 -35 35 -35 33 0 35 2 35 35 0 33 -2 35 -35 35 -33 0 -35 -2 -35 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQyWVsov2",
    d: "M510 275 c0 -34 1 -35 40 -35 39 0 40 1 40 35 0 34 -1 35 -40 35 -39 0 -40 -1 -40 -35z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l12c7uqK0oieHkAo1JuQzJV",
    fill: "rgb(206,98,120)",
    style: {
      transform: "none"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pZ6VldEVS",
    d: "M1478 2603 c27 -3 42 -9 42 -18 0 -7 -4 -15 -9 -17 -4 -1 -11 -14 -15 -28 -5 -18 0 -14 18 15 14 22 26 43 26 48 0 4 -24 6 -52 5 -51 -1 -51 -2 -10 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pB6HyXHh8",
    d: "M1348 2432 c13 -17 28 -35 34 -39 7 -3 2 8 -10 25 -13 17 -28 35 -34 39 -7 3 -2 -8 10 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSWo06wCO",
    d: "M1306 2240 c-162 -96 -209 -150 -129 -150 20 0 51 5 69 12 27 10 43 8 101 -11 83 -27 206 -98 270 -156 27 -23 77 -65 113 -94 149 -119 383 -369 502 -537 49 -69 131 -223 167 -315 72 -179 98 -396 66 -549 -10 -47 -20 -104 -22 -127 -4 -38 -3 -43 15 -43 11 0 35 19 55 43 190 232 197 564 21 907 -142 277 -556 687 -987 980 -133 90 -151 93 -241 40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pN1Urv4JN",
    d: "M330 706 c0 -32 2 -34 46 -40 81 -11 84 -10 84 28 0 31 -3 34 -37 40 -21 3 -50 6 -65 6 -25 0 -28 -4 -28 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzS6As4WE",
    d: "M580 475 c0 -33 2 -35 35 -35 33 0 35 2 35 35 0 33 -2 35 -35 35 -33 0 -35 -2 -35 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ns1amtD",
    d: "M620 380 c0 -39 1 -40 35 -40 34 0 35 1 35 40 0 39 -1 40 -35 40 -34 0 -35 -1 -35 -40z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l6kaKpM439wdi9AwBHHn9xj",
    fill: "rgb(245,144,159)",
    style: {
      transform: "none"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pNVFf1d4K",
    d: "M1240 2602 c0 -13 77 -130 118 -180 27 -33 37 -40 48 -31 17 14 104 152 104 165 0 5 -13 -11 -28 -36 -51 -84 -77 -120 -88 -120 -10 0 -109 132 -133 177 l-11 22 112 4 113 3 -117 2 c-65 1 -118 -2 -118 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSj9wzmFH",
    d: "M1493 2603 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVML3iGDF",
    d: "M1280 2222 c-395 -251 -796 -623 -983 -912 -140 -217 -196 -408 -184 -623 9 -155 57 -278 148 -380 109 -123 262 -189 434 -190 218 -1 420 102 599 306 85 96 90 95 229 -47 127 -129 202 -178 342 -225 173 -58 319 -50 471 23 191 92 311 295 321 541 3 61 0 128 -5 150 -7 29 -8 7 -4 -80 6 -140 -14 -239 -70 -351 -33 -66 -91 -144 -101 -134 -3 3 2 30 11 60 26 89 22 379 -6 494 -72 287 -237 549 -529 838 -70 70 -157 151 -193 179 -36 29 -86 71 -113 94 -62 56 -186 128 -267 155 -64 21 -133 23 -187 5 -15 -5 -23 -3 -23 4 0 10 69 58 170 119 19 12 30 22 25 22 -6 0 -44 -21 -85 -48z m-861 -1588 c38 -32 191 -234 191 -252 0 -20 -47 -62 -69 -62 -34 0 -147 114 -181 183 -33 65 -33 104 -2 140 20 22 25 22 61 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFtVlLzRz",
    d: "M1465 2241 c159 -91 500 -367 689 -556 258 -259 396 -466 462 -691 9 -31 18 -54 20 -51 9 9 -40 146 -86 242 -106 220 -324 470 -642 737 -206 173 -449 348 -482 348 -6 0 12 -13 39 -29z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l3DOHN6uUpru3dWTDZZvBkU",
    fill: "rgb(254,228,221)",
    style: {
      transform: "none"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1EAR5c9cs",
    d: "M1055 2065 c-167 -126 -304 -244 -430 -370 -211 -211 -332 -368 -416 -541 -40 -82 -90 -253 -88 -303 0 -14 9 13 19 61 10 48 24 104 30 125 19 60 96 209 148 287 132 200 447 512 737 730 95 72 112 86 104 86 -2 0 -49 -34 -104 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3MiNShe8",
    d: "M112 735 c0 -49 4 -103 8 -120 3 -16 5 20 3 80 -6 137 -12 160 -11 40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phLG9Trwz",
    d: "M331 676 c-15 -16 -24 -41 -28 -80 -5 -49 -2 -64 26 -120 36 -73 142 -180 186 -188 41 -8 93 10 112 38 28 43 18 89 -33 160 -142 199 -209 248 -263 190z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCJitpwES",
    d: "M135 550 c7 -51 78 -188 125 -242 52 -60 158 -130 240 -159 73 -25 258 -38 320 -22 25 7 2 8 -78 5 -190 -8 -321 38 -440 152 -68 65 -123 152 -154 244 -13 39 -17 46 -13 22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZwPwCff5",
    d: "M1327 477 c-12 -13 -48 -53 -79 -89 -69 -80 -196 -167 -309 -214 -46 -20 -71 -33 -54 -29 50 11 174 72 238 119 58 41 146 127 192 187 11 14 29 30 40 37 11 6 14 12 7 12 -7 0 -23 -11 -35 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4Vhx8Eat",
    d: "M1415 488 c11 -7 29 -23 40 -37 178 -232 467 -369 699 -333 72 11 201 55 211 73 3 4 -19 -3 -50 -16 -79 -35 -136 -46 -240 -46 -219 1 -440 113 -589 299 -43 55 -64 73 -84 72 -4 0 2 -6 13 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7xcornI3",
    d: "M2436 253 c-33 -31 -51 -51 -40 -45 32 17 119 104 102 102 -2 -1 -30 -26 -62 -57z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon1);
export default __webpack_public_path__ + "static/media/balloon1.52a7236766d83d149a256e591742ac02.svg";
export { ForwardRef as ReactComponent };